var applicationInfo = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationInfoCtrl ($scope, $sce, $location, $timeout, userStore) {
        var ctrl = this;
        var message;
        ctrl.messages = [];
        ctrl.step = 0;
        ctrl.totalSteps = [0,1];

        function init () {
            
        }

        function link () {
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Her er en guide til at vælge den rigtige e-mail 😎'),
                    type: 'receive'
                });
            }, 500);
        }

        function onUserUpdated(data) {
            if(!_.isEmpty(data)) {
                $timeout(function() {
                    $location.path('/din-ansoegning');
                }, 0);
            }   
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.next = function next(){
            ctrl.step++;
            ctrl.messages = [];
            ctrl.addMsg({
                content: $sce.trustAsHtml('For at arbejdspladsen ved hvem du er, skriv her'),
                type: 'receive'
            });
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

        $scope.$listenTo(userStore, ['user'], onUserUpdated);

    },
    templateUrl: './angular/components/application-info.component.html',
};